"use strict";

module.exports = function (accumulator, order, product, component) {
  if (!component.name_printing && !component.guest_addressing && !component.return_addressing) {
    return 'Blank Envelopes';
  }

  return accumulator;
};